import {
  MenuItem as ListItemButton,
  ListItemText,
  ListItemIcon
} from "@mui/material";

const MenuItem = ({
  sx,
  selected,
  label,
  secondary,
  TrailingIcon,
  LeadingIcon,
  ...props
}) => (
  <ListItemButton
    sx={{
      ...sx,
      height: 48,
      px: 1.5,
      bgcolor: selected ? "secondary.container" : undefined,
      "&:focused": {
        backgroundImage: theme =>
          `linear-gradient(${theme.palette.alpha(
            theme.palette.surface.on.color,
            0.08
          )}, ${theme.palette.alpha(theme.palette.surface.on.color, 0.08)})`
      }
    }}
    {...props}
  >
    {/* todo, double check specs on the Icons */}
    {LeadingIcon ? (
      <ListItemIcon>
        <LeadingIcon sx={{ color: "surface.on.variant" }} />
      </ListItemIcon>
    ) : null}
    <ListItemText
      primary={label}
      secondary={secondary}
      primaryTypographyProps={{
        variant: "labelLg",
        textTransform: "capitalize",
        color: selected ? "secondary.on.container" : "surface.on.color",
        sx: theme => theme.typography.lineClamp(2)
      }}
    />
    {TrailingIcon ? (
      <ListItemIcon>
        <TrailingIcon sx={{ color: "surface.on.variant" }} />
      </ListItemIcon>
    ) : null}
  </ListItemButton>
);

export default MenuItem;
